import type { CardHooks } from "./registry";

/**
 * Zeus' Wrathbrand — handled via the zeus-wrathbrand prompt in playUtility.
 * The prompt asks the player which opponent equipment slot(s) to disarm,
 * then confirmZeusWrathbrand applies the effect. This onEnter hook is a
 * no-op kept for registry parity (prevents double-disarm).
 */
export const zeusWrathbrand: CardHooks = {};
